import {
  RefObject,
  useEffect,
  useRef,
  useState,
  useSyncExternalStore,
} from 'react';

const getSnapshot = () => {
  return window.innerWidth;
};

const subscribe = (callback: () => void) => {
  window.addEventListener('resize', callback);
  return () => {
    window.removeEventListener('resize', callback);
  };
};

export const useScreenSize = () => {
  const screenSize = useSyncExternalStore(subscribe, getSnapshot);

  return screenSize;
};

export const useElementHeight = <T extends HTMLElement>(): [
  number,
  RefObject<T>
] => {
  const [height, setHeight] = useState<number>(0);
  const elementRef = useRef<T>(null);

  useEffect(() => {
    const updateHeight = () => {
      if (elementRef.current) {
        setHeight(elementRef.current.offsetHeight);
      }
    };

    updateHeight();

    const resizeObserver = new ResizeObserver(() => {
      updateHeight();
    });

    const currentElement = elementRef.current;
    if (currentElement) {
      resizeObserver.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        resizeObserver.unobserve(currentElement);
      }
    };
  }, []);

  return [height, elementRef];
};
